import styled from 'styled-components';
import { Button, Drawer, List, Tag } from 'antd';

export const SelectionCounter = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_sm};
`;

export const LinkButton = styled(Button)`
	height: auto;
	padding: 0;
	color: ${({ theme }) => theme.palette.primary[600]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_md};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
`;

export const IdentifyButton = styled(Button)`
	height: auto;
	padding: 0.5rem;
	border-color: ${({ theme }) => theme.palette.secondary[150]};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
`;

export const SegmentChipTag = styled(Tag)`
	max-width: 14rem;
	margin: 0;
	padding: 0.5rem;
	overflow: hidden;
	border-color: ${({ theme }) => theme.palette.primary[600]};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	background: ${({ theme }) => theme.palette.primary[100]};
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const TlidDrawerStyled = styled(Drawer)`
	.ant-drawer-header {
		padding: 2rem 2.5rem 1rem;
		border-bottom: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	}

	.ant-drawer-title {
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	}

	.ant-input-affix-wrapper {
		border-radius: ${({ theme }) => theme.border.border_radius.br_md};
	}

	.ant-drawer-body {
		display: flex;
		padding: 1rem 2.5rem 1.5rem;
	}

	.ant-drawer-footer {
		padding: 1.5rem 2.5rem;
		border-top: 1px solid ${({ theme }) => theme.palette.secondary[150]};

		.ant-btn {
			height: 2.5rem;
			border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
			font-size: 1rem;
		}
	}
`;

export const SegmentList: typeof List = styled(List)`
	.ant-list-item {
		height: 2.25rem;
		margin-bottom: 0.25rem;
		padding: 0 0.5rem;
		border-bottom: none;
		border-radius: ${({ theme }) => theme.border.border_radius.br_md};
	}

	.ant-list-item:has(.ant-checkbox-checked) {
		background: ${({ theme }) => theme.palette.primary[100]};
	}
`;

export const DrawerContent = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;

export const SegmentListArea = styled.div`
	flex: 1;
`;

export const CloseButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.25rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
`;
